import { pageInfo, deleteBatch, exportData, upload, downLoadTemplate } from './../api';
const whBaseData = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    deleteBatchObj: null,
    exportObj: null,
    uploadObj: null,
    templateObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    DELETE_BATCH(state, data) {
      state.deleteBatchObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    UPLOAD_DATA(state, data) {
      state.uploadObj = data;
    },
    DOWN_TEMPLATE(state, data) {
      state.templateObj = data;
    }
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async deleteBatch({ commit }, obj) {
      let resp = await deleteBatch(obj);
      commit('DELETE_BATCH', resp);
    },
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async upload({ commit }, obj) {
      let resp = await upload(obj);
      commit('UPLOAD_DATA', resp);
    },
    async downLoadTemplate({ commit }, obj) {
      let resp = await downLoadTemplate(obj);
      commit('DOWN_TEMPLATE', resp);
    }
  }
}
export default whBaseData



// WEBPACK FOOTER //
// ./src/page/assess/whBaseData/store/whBaseData.store.js